import { Routes, Route } from "react-router-dom";

// Pages
import Home from "./pages/static/Home";
import Login from "./pages/static/Login";
import Account from "./pages/account/Account";
import AllergenMenus from "./pages/account/AllergenMenus";
import Business from "./pages/business/Business";
import Error from "./pages/static/Error";
import Register from "./pages/static/Register";
import Subscription from "./pages/static/Subscription";
import Menu from "./pages/account/MenuBuilder/Menu";
import About from "./pages/static/About";
import Pricing from "./pages/static/Pricing";
import Contact from "./pages/static/Contact";
import BlogList from "./pages/static/blog/BlogList";
import BlogPost from "./pages/static/blog/BlogPost";

// Components
import Layout from "./pages/Layout";

// Auth
import { AuthProvider } from "./auth/auth-provider";
import UserLoggedIn from "./auth/UserLoggedIn";
import UserSubscribed from "./auth/UserSubscribed";

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route element={<Layout />}>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/about" element={<About />} />
          <Route exact path="/contact" element={<Contact />} />
          <Route exact path="/pricing" element={<Pricing />} />

          <Route path="/blog/:articleId" element={<BlogPost />} />
          <Route exact path="/blog" element={<BlogList />} />

          <Route exact path="/account/login" element={<Login />} />
          <Route exact path="/account/register" element={<Register />} />

          {/* Primary product page — business/menu/location management */}
          <Route
            exact
            path="/account/allergen-menus"
            element={
              <UserSubscribed>
                <AllergenMenus />
              </UserSubscribed>
            }
          />

          {/* Account settings — profile & subscription only */}
          <Route
            exact
            path="/account/my-account"
            element={
              <UserLoggedIn>
                <Account />
              </UserLoggedIn>
            }
          />

          <Route
            exact
            path="/account/subscription"
            element={
              <UserLoggedIn>
                <Subscription />
              </UserLoggedIn>
            }
          />

          <Route
            exact
            path="/account/menu/:businessId/:menuId"
            element={<Menu />}
          />
        </Route>
        <Route path="/:businessUri/:locationUri" element={<Business />} />
        <Route path="/:businessUri" element={<Business />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
